import api from './client';

// Inventory API
export const inventoryAPI = {
  // Item types (for dropdowns)
  getItemTypes: (collection?: string) =>
    api.get('/inventory-types', { params: collection ? { collection } : undefined }),

  // My inventory (sub manages their items)
  getMyInventory: (params?: { collection?: string; includeInactive?: boolean; itemTypeSlug?: string }) =>
    api.get('/inventory', { params }),
  createItem: (data: {
    name: string;
    description?: string;
    itemTypeId?: number;
    collectionType: string;
    visibility?: 'shared' | 'private';
    photoUrl?: string;
    photoUrls?: string[];
    metadata?: Record<string, any>;
  }, file?: File) => {
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', data.name);
      if (data.description) formData.append('description', data.description);
      if (data.itemTypeId !== undefined) formData.append('itemTypeId', String(data.itemTypeId));
      formData.append('collectionType', data.collectionType);
      if (data.visibility) formData.append('visibility', data.visibility);
      if (data.photoUrl) formData.append('photoUrl', data.photoUrl);
      if (data.metadata) formData.append('metadata', JSON.stringify(data.metadata));
      return api.post('/inventory', formData);
    }
    return api.post('/inventory', data);
  },
  updateItem: (id: string, data: {
    name?: string;
    description?: string;
    itemTypeId?: number | null;
    visibility?: 'shared' | 'private';
    photoUrl?: string;
    photoUrls?: string[];
    metadata?: Record<string, any>;
    isFavorite?: boolean;
    isActive?: boolean;
  }, file?: File) => {
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      if (data.name !== undefined) formData.append('name', data.name);
      if (data.description !== undefined) formData.append('description', data.description);
      if (data.itemTypeId !== undefined) formData.append('itemTypeId', String(data.itemTypeId));
      if (data.visibility) formData.append('visibility', data.visibility);
      if (data.photoUrl !== undefined) formData.append('photoUrl', data.photoUrl);
      if (data.metadata) formData.append('metadata', JSON.stringify(data.metadata));
      return api.put(`/inventory/${id}`, formData);
    }
    return api.put(`/inventory/${id}`, data);
  },
  deleteItem: (id: string) => api.delete(`/inventory/${id}`),
  toggleFavorite: (id: string) => api.post(`/inventory/${id}/favorite`),
  uploadPhoto: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/inventory/upload-photo', formData);
  },
  getItem: (id: string | number) => api.get(`/inventory/${id}`),

  // View user's shared inventory (Dom browsing sub's items)
  getUserInventory: (userId: number | string, params?: { collection?: string; itemTypeSlug?: string }) =>
    api.get(`/users/${userId}/inventory`, { params }),

  // For task dropdowns - owner_id and owner_ids accept UUID strings
  getInventoryForTasks: (params?: { collection?: string; ownerId?: string; ownerIds?: string }) =>
    api.get('/inventory/for-tasks', {
      params: params ? {
        collection: params.collection,
        owner_id: params.ownerId,
        owner_ids: params.ownerIds,
      } : undefined,
    }),

  // Assignments
  getTodayAssignments: () => api.get('/inventory/assignments/today'),
  assignItem: (id: number, data: {
    assignedToId: number;
    assignmentDate?: string;
    instructions?: string;
    requiresPhotoProof?: boolean;
    taskId?: number;
  }) => api.post(`/inventory/${id}/assign`, data),
  completeAssignment: (id: number, proofPhotoUrl?: string) =>
    api.post(`/inventory/assignments/${id}/complete`, { proofPhotoUrl: proofPhotoUrl }),

  // Super admin - item types
  getAllItemTypesAdmin: () => api.get('/admin/inventory-types'),
  createItemTypeAdmin: (data: { name: string; slug: string; collection: string; sortOrder?: number }) =>
    api.post('/admin/inventory-types', data),
  updateItemTypeAdmin: (id: number, data: { name?: string; slug?: string; collection?: string; sortOrder?: number; isActive?: boolean }) =>
    api.put(`/admin/inventory-types/${id}`, data),
  deleteItemTypeAdmin: (id: number) => api.delete(`/admin/inventory-types/${id}`),
};
